import React from 'react'

function ServiceItemCard({ title, description, imageUrl }) {
  return (
    <div className="flex items-center space-x-6 p-6 bg-background rounded-xl shadow mb-6 border"
        style={{ borderColor: '#D8C4B6' }}
    >
      <i className={`${imageUrl} text-3xl text-secondary`}></i>
      <div>
        <h3 className="text-xl font-ec text-textPrimary font-bold mb-2">{title}</h3>
        <p className="font-ec text-textSecondary">{description}</p>
      </div>
    </div>
  );
}
export default ServiceItemCard;